import { useState, useEffect } from 'react';
import i18n from 'i18next';

export const useLanguage = () => {
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'it');
  const [isInitialized, setIsInitialized] = useState(false);

  // Update state when language changes
  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setCurrentLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    // Set initial language if not set
    if (!currentLanguage) {
      setCurrentLanguage(i18n.language || 'it');
    }
    
    setIsInitialized(true);

    return () => {
      try {
        i18n.off('languageChanged', handleLanguageChange);
      } catch (error) {
        console.warn('Error removing i18n language change listener:', error);
      }
    };
  }, [currentLanguage]);

  const changeLng = async (lng: string) => {
    if (!isInitialized) {
      console.warn('i18n not initialized yet, cannot change language');
      return;
    }
    
    try {
      await i18n.changeLanguage(lng);
      console.log(`Language changed to: ${lng}`);
    } catch (error) {
      console.error('Error changing language:', error);
      // Optionally fallback to default language
      if (lng !== 'it') {
        try {
          await i18n.changeLanguage('it');
        } catch (fallbackError) {
          console.error('Error falling back to default language:', fallbackError);
        }
      }
    }
  };

  return {
    currentLanguage,
    changeLanguage: changeLng,
    isInitialized,
    languages: {
      en: 'English',
      it: 'Italiano',
      es: 'Español',
    }
  };
};